module.exports = __webpack_public_path__ + "static/img/3951_phase_function_Paper_Points.34692f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3951_phase_function_Paper_Points.png
// module id = vR91
// module chunks = 0